import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import CalenderIcon from '../../svgs/CalenderIcon';
import './AppDatePicker.scss';

interface IAppDatePicker{
  onChange?:any;
  placeholder?:string;
  value?:any;
  maxDate?: string;
  dateFormat?:any;
  className?:string;
  hasIcon?:boolean;
  showTimeSelect?:boolean;
  minDate?: any;
  disabled?: boolean;
  showMonthYearPicker?: boolean;
}

const AppDatePicker = ({
  onChange,
  placeholder,
  value,
  maxDate,
  dateFormat,
  className,
  hasIcon,
  showTimeSelect,
  minDate,
  disabled,
  showMonthYearPicker,
}:IAppDatePicker) => (
  <div
    style={{
      background: disabled ? 'rgba(245,245,245, 0.7)' : 'rgba(255, 255, 255, 0.1)',
    }}
    className={className || (value ? 'has-date-field' : 'empty-date-field')}
  >
    {
      value && <div className="date-label">{placeholder}</div>
    }

    <DatePicker
      onChange={onChange}
      placeholderText={placeholder}
      selected={value}
      dateFormat={dateFormat || 'dd/MM/yyyy'}
      maxDate={new Date(maxDate)}
      minDate={new Date(minDate)}
      showYearDropdown
      showMonthDropdown
      showMonthYearPicker={showMonthYearPicker}
      showTimeSelect={showTimeSelect}
      disabled={disabled}
    />
    {
      hasIcon && (
      <div className="calender_icon">
        {' '}
        <CalenderIcon />
      </div>
      )
    }

  </div>
);
export default AppDatePicker;
